export default __webpack_public_path__ + "fa9f5e6.png";